













import Vue from 'vue'

export default Vue.extend({
  name: 'UnitPanel',

  props: {
    contentTitle: {
      type: String as Prop<string>
    },

    unitTitle: {
      type: String as Prop<string>
    },

    hideHeader: {
      type: Boolean as Prop<boolean>,
      default: false
    }
  }
})
